import { render, staticRenderFns } from "./phva.vue?vue&type=template&id=8a6c2c84&scoped=true&"
import script from "./phva.vue?vue&type=script&lang=js&"
export * from "./phva.vue?vue&type=script&lang=js&"
import style0 from "./phva.vue?vue&type=style&index=0&id=8a6c2c84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6c2c84",
  null
  
)

export default component.exports